import React, {memo, useState, useCallback, useEffect, useRef} from 'react';
import { connect } from "react-redux";
import { Arrow, Text, Circle, Group, Stage, Layer, FastLayer, Rect, Line} from 'react-konva';
import NodeIO from './NodeIO.js';
import {
    INPUT,
    OUTPUT,
    NODE_WIDTH,
    NODE_COLOR,
    NODE_HEIGHT} from './constants.js';

const selectedColor = "red";
const MACRO_COLOR = "#0e2474b8";

const MacroComponent = memo(({
    macro,
    x,
    y,
    rack,
    setDragging,
    connectEdge,
    startDrawingEdge,
    drawingEdge,
    selected,
    selectedEdge,
    setSelectedEdge,
    rackRef,
    edges}) =>
{
    let text = macro.name;
    let width = 8 + text.length * 6;
    let outputs = [0];

    const onMouseDown = useCallback((e) => {
        if (!setDragging) {
            return;
        }
        let rect = rackRef.current.getBoundingClientRect();

        setDragging({
            effect: macro,
            x: (e.clientX - rect.left) - x,
            y: (e.clientY - rect.top) - y
        });
    }, [setDragging, x, y]);

    let color = selected ? selectedColor : MACRO_COLOR;

    return (
        <g>
         <rect
           className={selected ? "macro selected node" : "macro"}
           onMouseDown={(e) => onMouseDown(e)}
           fill={color}
           x={x}
           y={y}
           width={width}
           height={NODE_HEIGHT}/>
         <text
           className={selected ? "macro selected node-text" : "macro-text"}
           onMouseDown={(e) => onMouseDown(e)}
           fill={"white"}
           fontSize={10}
           fontFamily='Arial'
           x={x+3}
           y={y+10}
         >{text}
         </text>
         {outputs.map(
            (n,i) =>
                  <NodeIO
                    key={'output-' + i}
                    x={x}
                    y={y}
                    rack={rack}
                    parameter={n}
                    setSelectedEdge={setSelectedEdge}
                    selectedEdge={selectedEdge}
                    drawingEdge={drawingEdge}
                    number={i+1}
                    mode={OUTPUT}
                    connectEdge={connectEdge}
                    startDrawingEdge={startDrawingEdge}
                    effect={macro}
                />)}
        </g>
    );
});

const mapStateToProps = (state, props) => {
    return {
        x: props.macro.x,
        y: props.macro.y
    };
};

export default connect(mapStateToProps, null)(MacroComponent);
